<template>
  <div
    class="grid grid-cols-12 gap-0 border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50"
  >
    <!-- Operation Name Column -->
    <div class="col-span-4 py-1 px-2 flex items-center border-r border-gray-200 dark:border-gray-700">
      <!-- Name with icon -->
      <i :class="`pi ${isRecipe ? 'pi-list text-amber-500' : 'pi-wrench text-gray-500'} mr-1 flex-shrink-0`"></i>

      <span class="font-medium truncate flex-grow">
        {{ actionName }}
      </span>

      <!-- Loading indicator -->
      <i v-if="loading" class="pi pi-spin pi-spinner text-xs text-gray-500 ml-1 flex-shrink-0"></i>
    </div>

    <!-- Status Cell -->
    <StatusCell :status="assignment.status" :date="assignment.created_at" />

    <!-- Hours Cell -->
    <HoursCell :hours="laborHours" :mechanics-count="mechanics.length" />

    <!-- Financial Cells -->
    <FinancialCell :value="chargedAmount" />
    <FinancialCell :value="actualAmount" />
    <FinancialCell :value="quoteAmount" />

    <!-- Actions Cell -->
    <div class="col-span-1 py-2 px-2 flex items-center justify-center gap-1">
      <button @click="handleEdit" class="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" title="Edit assignment">
        <i class="pi pi-pencil text-blue-500 dark:text-blue-400 text-sm" />
      </button>
      <button @click="$event => handleDelete($event)" class="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded" title="Delete assignment">
        <i class="pi pi-trash text-red-500 dark:text-red-400 text-sm" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import StatusCell from './cells/StatusCell.vue';
import HoursCell from './cells/HoursCell.vue';
import FinancialCell from './cells/FinancialCell.vue';

interface Mechanic {
  id: string;
  name: string;
}

interface Assignment {
  id: string;
  status: string;
  created_at?: string;
  action?: {
    id: string;
    name?: string;
    price?: number | string;
  };
}

const props = defineProps<{
  assignment: Assignment;
  index: number;
  isRecipe: boolean;
  actionName: string;
  loading: boolean;
  laborHours: number;
  mechanics: Mechanic[];
  chargedAmount?: number | string;
  actualAmount?: number | string;
  quoteAmount?: number | string;
}>();

const emit = defineEmits<{
  (e: 'edit', assignment: Assignment): void;
  (e: 'delete', assignment: Assignment, event: Event): void;
  (e: 'view-financials', assignment: Assignment): void;
}>();

const actions = [
  {
    id: 'edit',
    icon: 'pi pi-pencil',
    severity: 'info',
    title: 'Edit assignment'
  }
];

function handleEdit() {
  emit('edit', props.assignment);
}

function handleDelete(event: Event) {
  emit('delete', props.assignment, event);
}
</script>
